module.exports = __webpack_public_path__ + "img/IMG_9432_L.2b72e103.webp";